/**
 * Custom results-list component to handle content-only searches.
 */
if (!customElements.get('results-list')) {
  customElements.define('results-list', class ResultsList extends HTMLElement {
    constructor() {
      super();
      this.container = this.querySelector('.collection-wrapper');
      this.form = document.querySelector('form[role="search"]');
      
      // Force the search type globally for this component
      this.searchType = 'article,page';
      
      this.init();
    }

    init() {
      // Intercept any form submissions to ensure type is correct
      if (this.form) {
        this.form.addEventListener('submit', (e) => {
          const typeInput = this.form.querySelector('input[name="type"]');
          if (typeInput) {
            typeInput.value = this.searchType;
          } else {
            const hiddenType = document.createElement('input');
            hiddenType.type = 'hidden';
            hiddenType.name = 'type';
            hiddenType.value = this.searchType;
            this.form.appendChild(hiddenType);
          }
        });
      }

      // Check URL on load - if it says product, redirect immediately
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.get('type') === 'product') {
        urlParams.set('type', this.searchType);
        window.location.search = urlParams.toString();
      }
    }

    // Handles infinite scroll and pagination refreshes
    async renderResults(url) {
      const targetUrl = new URL(url, window.location.origin);
      targetUrl.searchParams.set('type', this.searchType);
      
      try {
        const response = await fetch(targetUrl.href);
        const text = await response.text();
        const html = new DOMParser().parseFromString(text, 'text/html');
        const newResults = html.querySelector('.collection-wrapper');

        if (newResults && this.container) {
          this.container.innerHTML = newResults.innerHTML;
        }
      } catch (e) {
        console.error('Search update failed:', e);
      }
    }
  });
}